// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1hLXy","content":"LayoutSettings_content__1lQxP"};